export const defaultMetaTitle = 'Virgin Experience Days UK | Experience Gifts & Presents';

export const defaultMetaDescription =
  'Virgin Experience Days is the perfect place for great gift ideas. Click to find great gifts including Driving, Pampering, Animal and Flying Experiences.';
